import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_sgo5bMYlgkdh: {
	id: 'prd_sgo5b2DEV2MYlgkdh'
	ident: 'prd_sgo5bMYlgkdh'
	sku: 'simple_premium_4w_9_59_4w_52_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_qenLX2DEV22CpCk4x'
			amount: 52
			amount_usd: 9.59
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 9.59
			discount: 42.41
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_W7VOp2DEV2MBWqZgD'
			amount: 52
			amount_usd: 52
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_sgo5bMYlgkdh, SubscriptionProduct>
const prd_sgo5bMYlgkdh = { ident: 'prd_sgo5bMYlgkdh' } as typeof _prd_sgo5bMYlgkdh

export default prd_sgo5bMYlgkdh
